import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function PinIcon(props: ACIconProps) {
  return <ACIconWrapper {...props} component={IconSvg} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.75 5.5C10.4185 5.5 10.1005 5.6317 9.86612 5.86612C9.6317 6.10054 9.5 6.41848 9.5 6.75V10C9.5 10.0912 9.48335 10.1817 9.45087 10.267L7.8383 14.5H16.1617L14.5491 10.267C14.5167 10.1817 14.5 10.0912 14.5 10V6.75C14.5 6.41848 14.3683 6.10054 14.1339 5.86612C13.8995 5.6317 13.5815 5.5 13.25 5.5H10.75ZM8.80546 4.80546C9.32119 4.28973 10.0207 4 10.75 4H13.25C13.9794 4 14.6788 4.28973 15.1945 4.80546C15.7103 5.32118 16 6.02065 16 6.75V9.86198L17.9509 14.983C18.0387 15.2135 18.0075 15.4725 17.8676 15.6756C17.7276 15.8787 17.4967 16 17.25 16H12.75V19.25C12.75 19.6642 12.4142 20 12 20C11.5858 20 11.25 19.6642 11.25 19.25V16H6.75C6.50333 16 6.27243 15.8787 6.13245 15.6756C5.99247 15.4725 5.96132 15.2135 6.04914 14.983L8 9.86198V6.75C8 6.02065 8.28974 5.32118 8.80546 4.80546Z"
        fill="currentColor"
      />
    </svg>
  );
};
